import React from 'react';

interface NewTicketOptionalFieldsProps {
  phone: string;
  setPhone: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  regNumber: string;
  setRegNumber: (value: string) => void;
  bookingNumber: string;
  setBookingNumber: (value: string) => void;
  t: (key: string) => string;
}

export const NewTicketOptionalFields: React.FC<NewTicketOptionalFieldsProps> = ({
  phone,
  setPhone,
  email,
  setEmail,
  regNumber,
  setRegNumber,
  bookingNumber,
  setBookingNumber,
  t,
}) => {
  const inputClass =
    'w-full px-3 py-2 border border-border rounded-lg text-sm bg-bgBase text-textDefault';

  return (
    <>
      <input
        type="tel"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        placeholder={t('chat.phoneOptional')}
        className={`${inputClass} mb-3`}
      />
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t('chat.emailOptional')}
        className={`${inputClass} mb-3`}
      />
      <input
        type="text"
        value={regNumber}
        onChange={(e) => setRegNumber(e.target.value)}
        placeholder={t('chat.regNumberOptional')}
        className={`${inputClass} mb-3 uppercase`}
      />
      <input
        type="text"
        value={bookingNumber}
        onChange={(e) => setBookingNumber(e.target.value)}
        placeholder={t('chat.bookingNumberOptional')}
        className={`${inputClass} mb-3`}
      />
    </>
  );
};
